import { css } from "@emotion/react";

export const LinkEllipsisContainer = css`
  overflow: hidden;

  position: relative;
  background-color: white;

  margin-bottom: 8px;
  line-height: 20px;
  max-height: 4em;
  word-break: break-all;

  &:before {
    content: "...";
    position: absolute;
    z-index: 0;
    background-color: inherit;
    right: 0;
    bottom: 0;
  }
  &:after {
    content: "";
    position: absolute;
    right: 0;
    width: 1em;
    height: 1em;
    margin-top: 0.2em;
    background: white;
  }
`;

export const LinkEllipsisStyles = css`
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
`;
